import { fuelCardTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { list as driversList } from "sources/books/drivers";
import { list as numbersList } from "sources/books/trucks";

const config = {
    number: {
        label: "Номер",
        inputProps: { name: "number", maxLength: 32 },
        validators: [requiredField],
        required: true,
    },
    type: {
        label: "Тип карты",
        inputProps: { name: "type" },
        validators: [requiredField],
        required: true,
        menuPortalTarget: document.body,
        options: fuelCardTypes,
    },
    hasNoLimitManagement: {
        checkbox: true,
        label: "Без управления лимитами",
        inputProps: { name: "hasNoLimitManagement" },
    },
    carId: {
        // async-select
        label: "Машина",
        inputProps: { name: "carId" },
        url: numbersList,
        propName: "number",
        menuPortalTarget: document.body,
    },
    driverId: {
        // async-select
        label: "Водитель",
        inputProps: { name: "driverId" },
        url: driversList,
        propName: "user.fullName",
        filterPropName: "user/fullName",
        menuPortalTarget: document.body,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
